import { on } from '@ember/modifier';

import type { Args } from 'webapp/components/common/request-trial-base';
import CommonRequestTrialBaseComponent from 'webapp/components/common/request-trial-base';

export default class CommonRequestTrialLinkComponent<
	T extends Args,
> extends CommonRequestTrialBaseComponent<T> {
	<template>
		<a role="button" {{on "click" this.requestTrial}} class="request-trial-link">
			{{this.text}}
		</a>
	</template>
}
